import { GAEventName } from 'analytics/ga-event-name.enum';
import { StoreCode } from 'schema/storeCode';
import { createAnalyticsEvent } from '../create-analytics-event';

export const changeOrderDateEvent = createAnalyticsEvent<{
  orderId: number;
  date: string | null;
  store: StoreCode;
  eventName?: GAEventName;
}>(({ orderId, date, store, eventName }) => ({
  event: eventName || GAEventName.CHANGE_ORDER_DATE,
  orderId,
  date,
  store
}));

export const skipOrderEvent = createAnalyticsEvent<{
  orderId: number;
  store: StoreCode;
}>(({ orderId, store }) => ({
  event: GAEventName.SKIP_ORDER,
  orderId,
  store
}));

export const shipNowOrderEvent = createAnalyticsEvent<{
  orderId: number;
  store: StoreCode;
}>(({ orderId, store }) => ({
  event: GAEventName.SHIP_NOW,
  orderId,
  store
}));
